module.exports = __webpack_public_path__ + "img/6.df1ce890.webp";